import {
  TenantUserColumns,
  TenantUserUsecaseInterface,
  UpdateStatusParams,
} from "./usecase.d";
import { TenantUserRepository } from "../../services/TenantUser/tenantUser.repository";
import * as TenantUserReducer from "./reducer";
import { ActionType } from "./types";
import {
  DeleteParams,
  GetListParams,
} from "../../services/TenantUser/tenantUser.repository.d";
import { CreateTenantUserDto } from "../../services/TenantUser/dto/create.dto";
import { UpdateTenantUserDto } from "../../services/TenantUser/dto/update.dto";
import { Constant } from "../../common/constant";
import { LocalStorage } from "../../modules/LocalStorage";

const TENANT_USER_COLUMN_KEY = "TenantUserColumns";

const defaultColumns: TenantUserColumns = {
  userFirstName: true,
  userLastName: true,
  userEmail: true,
  userRole: true,
  isActive: true,
};

export class TenantUserUsecase implements TenantUserUsecaseInterface {
  dispatch?: TenantUserReducer.TenantUserDispatch;
  repository: TenantUserRepository;

  constructor(dispatch?: TenantUserReducer.TenantUserDispatch) {
    this.repository = new TenantUserRepository();
    this.dispatch = dispatch;
  }

  async getList(params: GetListParams) {
    const apiParams = { ...params };
    if (
      !apiParams.role ||
      apiParams.role === Constant.role.all ||
      (Array.isArray(apiParams.role) &&
        apiParams.role.includes(Constant.role.all))
    ) {
      apiParams.role = [
        Constant.role.superModerator,
        Constant.role.moderator,
        Constant.role.sale,
        Constant.role.designStudio,
        Constant.role.homeExplorerUser,
      ];
    }
    const response = await this.repository.getList(apiParams);

    if (this.dispatch) {
      this.dispatch({
        type: ActionType.GetList,
        items: response,
      });
    }
  }

  async create(params: CreateTenantUserDto) {
    const response = await this.repository.create(params);

    if (this.dispatch) {
      this.dispatch({
        type: ActionType.Create,
        addedItem: response.data,
      });
    }
  }

  async update(params: UpdateTenantUserDto) {
    const response = await this.repository.update(params);

    if (this.dispatch) {
      this.dispatch({
        type: ActionType.Update,
        updatedItem: response.data,
      });
    }
  }

  async updateStatus(params: UpdateStatusParams) {
    if (this.dispatch) {
      this.dispatch({
        type: ActionType.UpdateStatus,
        updatedStatusItem: params,
      });
    }

    try {
      await this.repository.update({
        id: params.id,
        isActive: params.isActive,
      });
    } catch (error) {
      if (this.dispatch) {
        this.dispatch({
          type: ActionType.UpdateStatus,
          updatedStatusItem: {
            id: params.id,
            isActive: !params.isActive,
          },
        });
      }
      throw error;
    }
  }

  async delete({ id }: DeleteParams) {
    await this.repository.delete({ id });

    if (this.dispatch) {
      this.dispatch({
        type: ActionType.Delete,
        deletedId: id,
      });
    }
  }

  getDisplayColumns() {
    const columns = LocalStorage.getShowHideColumns<TenantUserColumns>(
      TENANT_USER_COLUMN_KEY,
    );

    const defaultKeys = Object.keys(defaultColumns);
    if (
      !columns ||
      defaultKeys.length !== Object.keys(columns).length ||
      defaultKeys.some((key) => !(key in columns))
    ) {
      return defaultColumns;
    }
    return columns;
  }

  setDisplayColumns(columns: TenantUserColumns) {
    LocalStorage.setShowHideColumns(TENANT_USER_COLUMN_KEY, columns);
  }
}
